export default __webpack_public_path__ + "static/media/voipPhone.973ab0db.svg";